let resolveReady: () => void = () => {};

/**
 * Resolves once amplitude.init() has fully finished. Until then the SDK may report itself ready while it
 * has no destination plugin yet, and events dispatched in that window are silently dropped (LAAC-2563).
 */
export const amplitudeAnalyticsReady = new Promise<void>((resolve) => {
    resolveReady = resolve;
});

export const markAmplitudeAnalyticsReady = () => resolveReady();
